import useActivitiesDisplayName from '../../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import useValueMessageDisplayName from '../../../shared/hooks/useDisplayNames/variants/useValueMessageDisplayName'
import { StrategicImperativeDisplayNames } from './StrategicImperativeTable.types'

export const useStrategicImperativeDisplayNames = (): StrategicImperativeDisplayNames => ({
    activities: useActivitiesDisplayName().plural,
    valueMessages: useValueMessageDisplayName().plural,
})
